import { useCallback } from "react";
import type { CaptureSessionResponse } from "lib/api-types/schemas";
import { useUpdatePatientCardCache } from "./useUpdatePatientCardCache";

export function useUpdateCaptureCache(patientId: string) {
  const updatePatientCardCache = useUpdatePatientCardCache(patientId);

  return useCallback(
    (response: CaptureSessionResponse) => {
      if (response.notificationSent) {
        const cardCapture = {
          sessionId: response.captureSessionId!,
          state: "sent",
        } as const;
        updatePatientCardCache({ cardCapture });
      }
    },
    [updatePatientCardCache],
  );
}
